import { useField } from 'formik';

import { controlError } from 'utils/error';
import { RichText, RichTextProps } from 'components/rich-text';

export type RichTextFieldProps = RichTextProps & {
  name: string;
};

export const RichTextField = ({
  name,
  label,
  onBlur,
  onChange,
  placeholder,
  allowImages,
  acceptPlainText,
}: RichTextFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);
  const hasError = Boolean(errorText);

  const handleChange = (value: string) => {
    helpers.setValue(value);
    onChange?.(value);
  };

  return (
    <>
      <RichText
        editable
        label={label}
        error={hasError}
        fieldName={name}
        value={field.value}
        helperText={errorText}
        onChange={handleChange}
        placeholder={placeholder}
        allowImages={allowImages}
        acceptPlainText={acceptPlainText}
        onBlur={() => {
          helpers.setTouched(true);
          onBlur?.();
        }}
      />
    </>
  );
};
